import request from "@/utils/request";
import Qs from "qs";

const api = {
  findAll: "/api/role/findAll",
  findPage: "/api/role/findPage",
  save: "/api/role/save",
  del: "/api/role/delete",
  saveAuth: "/api/role/save-auth",
  findDataAuth: "/api/role/find-data-auth",
  saveDataAuth: "/api/role/save-data-auth",
  findByRoleCode: "/api/role/findByRoleCode"
};

export function findAll(parameter) {
  return request({
    url: api.findAll,
    method: "get",
    params: parameter
  });
}

export function findByRoleCode(parameter) {
  return request({
    url: api.findByRoleCode,
    method: "get",
    params: parameter
  });
}

export function findPage(parameter) {
  return request({
    url: api.findPage,
    method: "get",
    params: parameter
  });
}

export function save(parameter) {
  return request({
    url: api.save,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

export function del(parameter) {
  return request({
    url: api.del,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
export function saveAuth(parameter) {
  return request({
    url: api.saveAuth,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
export function findDataAuth(parameter) {
  return request({
    url: api.findDataAuth,
    method: "get",
    params: parameter
  });
}

export function saveDataAuth(parameter) {
  return request({
    url: api.saveDataAuth,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
